import React, { useEffect, useState } from "react";
import api from "../../api/axiosClient";
import { getMakeupArtists } from "../../services/makeupArtistService";

export default function Register() {
  const [form, setForm] = useState({
    username: "",
    password: "",
    fullName: "",
    email: "",
    phone: "",
    roleId: 2, // default to Artist
    makeupArtistId: "" as number | "",
  });

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [artists, setArtists] = useState<Array<{ id: number; displayName: string }>>([]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setMessage("");

    try {
      const payload: any = { ...form };
      if (payload.makeupArtistId === "") delete payload.makeupArtistId;
      await api.post("/Auth/Register", payload);
      setMessage("Registration successful! You can now log in.");
    } catch (err: any) {
      const msg = err?.response?.data || err?.message || "Registration failed";
      setError(String(msg));
    }
  };

  useEffect(() => {
    // Load artists and artist types for dropdowns
    getMakeupArtists()
      .then((list) => setArtists(list))
      .catch(() => setArtists([]));
  }, []);

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="bg-white shadow-lg rounded-xl p-8 w-full max-w-md">
        <h2 className="text-2xl font-bold text-center mb-6 text-pink-600">
          Register
        </h2>

        {message && <div className="bg-green-100 text-green-600 p-2 mb-4 rounded">{message}</div>}
        {error && <div className="bg-red-100 text-red-600 p-2 mb-4 rounded">{error}</div>}

        <form onSubmit={handleSubmit} className="space-y-4">
          <input name="username" onChange={handleChange} placeholder="Username" className="w-full border p-2 rounded" required />
          <input name="fullName" onChange={handleChange} placeholder="Full Name" className="w-full border p-2 rounded" required />
          <input name="email" onChange={handleChange} placeholder="Email" className="w-full border p-2 rounded" />
          <input name="phone" onChange={handleChange} placeholder="Phone" className="w-full border p-2 rounded" />
          <input name="password" type="password" onChange={handleChange} placeholder="Password" className="w-full border p-2 rounded" required />


          {/* Optional: Associate with a Makeup Artist */}
          <div>
            <label className="block text-sm text-gray-700 mb-1">Makeup Artist (optional)</label>
            <select
              className="w-full border p-2 rounded"
              value={form.makeupArtistId}
              onChange={(e) => setForm({ ...form, makeupArtistId: e.target.value === "" ? "" : Number(e.target.value) })}
            >
              <option value="">Select a makeup artist</option>
              {artists.map((a) => (
                <option key={a.id} value={a.id}>{a.displayName}</option>
              ))}
            </select>
          </div>

          <button type="submit" className="w-full btn-primary mt-2">
            Register
          </button>
        </form>
      </div>
    </div>
  );
}
